import {
  TOGGLE_MODAL,
  START_MODAL_FADE,
  SET_MODAL,
  SET_PLAN_MODAL,
  TOGGLE_PLAN_MODAL,
  SUCCESS_MESSAGE,
  RESET_SUCCESS_MESSAGE
} from '../actions/types';

const INITIAL_STATE = {
  show: false,
  type: '',
  startFade: false,
  title: '',
  description: '',
  icon: '',
  onPress: null,
  onCancel: null,
  submit: '',
  cancel: '',
  plan: {},
  toggle_plan: "monthly",
  success_message: "",
  buttonType: "primary"

}

export default (state = INITIAL_STATE, action) => {

  switch(action.type){
    case TOGGLE_MODAL:
      return {
        ...state,
        startFade: false,
        show: action.payload.show,
        type: action.payload.show ? action.payload.type : null
      }
    case SET_MODAL:
      return {
        ...state,
        title: action.payload.title,
        description: action.payload.description,
        icon: action.payload.icon,
        submit: action.payload.submit,
        buttonType: action.payload.buttonType,
        cancel: action.payload.cancel,
        onPress: action.payload.onPress,
        onCancel: action.payload.onCancel
      }
    case SET_PLAN_MODAL:
      return {
        ...state,
        plan: action.payload.plan
      }
    case TOGGLE_PLAN_MODAL:
      return {
        ...state,
        toggle_plan: action.payload
      }
    case START_MODAL_FADE:
      return {
        ...state,
        startFade: true
      }
    case SUCCESS_MESSAGE:
      return {
        ...state,
        success_message: action.payload
      }
    case RESET_SUCCESS_MESSAGE:
      return{
        ...state,
        success_message: ""
      }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/ModalReducer.js